import { render, staticRenderFns } from "./EventBasedGateway.vue?vue&type=template&id=410e2ce1&scoped=true&"
import script from "./EventBasedGateway.vue?vue&type=script&lang=js&"
export * from "./EventBasedGateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410e2ce1",
  null
  
)

export default component.exports